const discountCouponTypes = {
  0: 'Valor exato',
  1: 'Porcentagem',
}

export default discountCouponTypes
